import React from 'react'
import { Box, Button, Card, CardContent, Divider, Grid, List, ListItemText, Stack, Typography } from '@mui/material'
import CommentIcon from '@mui/icons-material/Comment'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import SignalWifiStatusbar4BarIcon from '@mui/icons-material/SignalWifiStatusbar4Bar'
import Span from '@jumbo/shared/Span'
import { formattedDate } from 'app/services/utils/components/FormatDateTime/FormatDateTime'
import formatCurrency from 'app/utils/components/formatCurrency/formatCurrency'

const textFontSx = {
    fontFamily: (theme) => theme.typography.fontFamily,
    fontWeight: 600,
}

const bodyFontSx = {
    fontFamily: (theme) => theme.typography.fontFamily,
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5,
}

const RightInfoCard = ({ transaction, isCancelled, onCancelClick }) => {
    return (
        <Grid>
            <Card
                sx={{
                    height: { xs: 'auto', md: 300 },
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                <CardContent
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        pb: 2,
                    }}>
                    <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        sx={{ display: 'flex', justifyContent: 'space-between', flex: 1 }}>
                        <Grid item xs={12} sx={{ width: '100%', display: 'flex', alignItems: 'center', ml: { xs: 1.9 } }}>
                            <List sx={{ width: '100%', color: 'text.primary' }}>
                                <ListItemText
                                    disablePadding
                                    primary={
                                        <Typography variant={'h5'} color='text.primary' sx={textFontSx}>
                                            <RequestQuoteIcon sx={{ fontSize: 25, mb: -0.5, mr: 1.5 }} />
                                            The amount
                                            <Span sx={{ color: 'secondary.dark' }}>
                                                {' '}
                                                {formatCurrency(transaction.amountPaid)}
                                            </Span>{' '}
                                            is paid and <br />
                                            <Span sx={{ marginLeft: '11%' }}>total amount is </Span>
                                            <Span sx={{ color: 'secondary.dark' }}>
                                                {' '}
                                                {formatCurrency(transaction.totalAmount)}.{' '}
                                            </Span>
                                        </Typography>
                                    }
                                />
                                <ListItemText sx={{ mt: 1.7 }}>
                                    <Typography variant={'h5'} color='text.primary' sx={textFontSx}>
                                        <SignalWifiStatusbar4BarIcon sx={{ fontSize: 25, mb: -0.5, mr: 1.5 }} />
                                        Balance
                                        <Span sx={{ color: 'secondary.dark' }}>
                                            {' '}
                                            {formatCurrency(transaction.balance)}{' '}
                                        </Span>{' '}
                                        is due on <br />
                                        <Span sx={{ color: 'secondary.dark', marginLeft: '11%' }}>
                                            {transaction.dueDateTxn ? formattedDate(transaction.dueDateTxn) : ''}{' '}
                                        </Span>{' '}
                                        (due date)
                                    </Typography>
                                </ListItemText>
                            </List>
                        </Grid>
                        <Grid item sx={{ width: '45%', display: 'flex', alignItems: 'right', ml: 1.9 }}>
                            <List sx={{ width: '100%' }}>
                                <ListItemText>
                                    <Typography variant={'h5'} color='text.primary' sx={textFontSx}>
                                        <CommentIcon sx={{ fontSize: 25, mb: -0.5, mr: 1.5 }} />
                                        Comments
                                    </Typography>
                                </ListItemText>
                                <Divider sx={{ mb: 2, width: '100%' }} />
                                <ListItemText>
                                    {transaction.comments && (
                                        <Typography variant='body1' color='secondary.dark' sx={bodyFontSx}>
                                            {transaction.comments}
                                        </Typography>
                                    )}
                                </ListItemText>
                            </List>
                        </Grid>
                    </Stack>
                    {!isCancelled && onCancelClick && (
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start', pl: { xs: 1.9, md: 1.9 } }}>
                            <Button
                                variant='contained'
                                color='warning'
                                onClick={onCancelClick}
                                sx={{
                                    color: 'common.white',
                                    textTransform: 'none',
                                    fontFamily: (theme) => theme.typography.fontFamily,
                                    fontWeight: 600,
                                    '&:hover': {
                                        bgcolor: 'warning.dark',
                                    },
                                }}>
                                Cancel Transaction
                            </Button>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Grid>
    )
}

export default RightInfoCard
